import React from 'react'
import Header from './components/Header'
import DataWrapper from './components/DataWrapper'
import Copywrite from './components/copywrite'
import Footer from "../../components/Footer"
const Privacy = () => {
  return (
    <div>
      <Header Title="Privacy Policy" lastUpdated="Last Updated on January 1st, 2025" />
      <div className='md:p-12 p-6 max-w-7xl mx-auto'>
        <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
          This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from Respoclear.net (the “Site”).
        </p>
        {/* 1 */}
        <DataWrapper heading="PERSONAL INFORMATION WE COLLECT">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            By using our website, you (the visitor) agree to allow third parties to process your IP address in order to determine your location for the purpose of currency conversion. You also agree to have that currency stored in a session cookie in your browser (a temporary cookie that gets automatically removed when you close your browser). We do this in order for the selected currency to remain consistent when browsing our website so that the prices can convert to your (the visitor's) local currency.
          </p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            We collect Device Information using the following technologies:
          </p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px] list-disc ml-8">
            <li>
              <span className='font-bold text-black'>Cookies:</span> Data files that are placed on your device or computer and often include an anonymous unique identifier. For more information about cookies and how to disable them, visit <a href='http://www.allaboutcookies.org' className='hover:underline text-blue-600'>http://www.allaboutcookies.org</a> .
            </li>
            <li>
              <span className='font-bold text-black'>Log files:</span> Track actions occurring on the Site and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.
            </li>
            <li>
              <span className='font-bold text-black'>Web beacons, tags,</span> and <span className='font-bold text-black'>pixels:</span> Electronic files used to record information about how you browse the Site.
            </li>
          </ul>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Additionally, when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including:
          </p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-bold  mb-[15px] list-disc ml-8">
            <li>
              Name
            </li>
            <li>
              Billing address
            </li>
            <li>
              Shipping address
            </li>
            <li>
              Payment information <span className='font-normal'>(including credit card numbers)</span>
            </li>
            <li>
              Email address
            </li>
            <li>
              Phone number
            </li>
          </ul>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            We refer to this information as “Order Information”.
          </p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            When we talk about “Personal Information” in this Privacy Policy, we are referring to both Device Information and Order Information.
          </p>
        </DataWrapper>
        {/* 2 */}
        <DataWrapper heading="HOW DO WE USE YOUR PERSONAL INFORMATION?">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            We use the Order Information that we collect to:</p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px] list-disc ml-8">
            <li>
              Fulfill any orders placed through the Site (including processing your payment information, arranging for shipping, and providing you with invoices and/or order confirmations).
            </li>
            <li>
              Communicate with you.
            </li>
            <li>
              Screen our orders for potential risk or fraud.
            </li>
            <li>
              Provide you with information or advertising relating to our products or services, in line with the preferences you have shared with us.
            </li>
          </ul>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            We use the Device Information that we collect to:</p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px] list-disc ml-8">
            <li>
              Help us screen for potential risk and fraud (in particular, your IP address).
            </li>
            <li>
              Improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site).
            </li>
            <li>
              Assess the success of our marketing and advertising campaigns.
            </li>
          </ul>
        </DataWrapper>
        {/* 3 */}
        <DataWrapper heading="SHARING YOUR PERSONAL INFORMATION">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            We share your Personal Information with third parties to help us use your Personal Information as described above. For example:</p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px] list-disc ml-8">
            <li>
              We use Google Analytics to understand how our customers use the Site—you can read more about how Google uses your Personal Information here: <a href='https://www.google.com/intl/en/policies/privacy/ ' className='hover:underline text-blue-600'>https://www.google.com/intl/en/policies/privacy/</a>  . You can opt-out of Google Analytics here: <a href='https://tools.google.com/dlpage/gaoptout' className='text-blue-600 hover:underline'> https://tools.google.com/dlpage/gaoptout</a> .

            </li>
          </ul>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            The above excludes text messaging originator opt-in data and consent; this information will not be shared with any third parties.
          </p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Finally, we may share your Personal Information to comply with applicable laws and regulations, respond to a subpoena, search warrant, or other lawful requests for information we receive, or to otherwise protect our rights.
          </p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-bold ">
            Opting Out of Targeted Advertising:
          </p>
          <ul>
            <li>
              Facebook: <a href='https://www.facebook.com/settings/?tab=ads' className='text-blue-600 hover:underline'>https://www.facebook.com/settings/?tab=ads</a>
            </li>
          </ul>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Additionally, you can opt out of some of these services by visiting the <span className='font-bold'>Digital Advertising Alliance’s opt-out portal at:</span><br />
            <span>
              <a href='http://optout.aboutads.info/.' className='hover:underline text-blue-500'>http://optout.aboutads.info/</a>
            </span>

          </p>
        </DataWrapper>
        {/* 4 */}

        <DataWrapper heading="DO NOT TRACK">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.</p>
        </DataWrapper>
        {/* 5 */}
        <DataWrapper heading="YOUR RIGHTS">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.</p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            For European Residents:
          </p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal space-y-3  mb-[15px] list-disc ml-8">
            <li>
              You have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted.
            </li>
            <li>
              To exercise this right, please contact us using the contact information provided below.
            </li>
            <li>
              We process your information to fulfill contracts we might have with you (e.g., if you make an order through the Site) or otherwise to pursue our legitimate business interests.
            </li>
            <li>
              Please note that your information will be transferred outside of Europe, including to Canada and the United States.
            </li>
          </ul>
        </DataWrapper>
        {/* 6 */}
        <DataWrapper heading="DATA RETENTION">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete it.
          </p>
        </DataWrapper>
        {/* 7 */}
        <DataWrapper heading="CHANGES">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            We may update this Privacy Policy from time to time to reflect changes to our practices or for other operational, legal, or regulatory reasons.
          </p>
        </DataWrapper>
        {/* 8 */}
        <DataWrapper heading="CONTACT US">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            For more information about our privacy practices, questions, or complaints, please contact us:
          </p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-nomral space-y-3  mb-[15px] list-disc ml-8">
            <li>
              <span className='font-bold'>Email:</span> support@herbalteatherapy.com
            </li>
            <li>
              <span className='font-bold'>Mail:</span>

              <br />
              Respoclear.net<br />
              [Re: Privacy Compliance Officer]

            </li>
          </ul>
        </DataWrapper>
        {/* 9 */}
        <DataWrapper heading="UNSUBSCRIBE FROM COMMUNICATIONS">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            If you no longer wish to receive marketing emails from us:</p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-nomral space-y-3  mb-[15px] list-disc ml-8">
            <li>
              Click the "unsubscribe" link at the bottom of any email.

            </li>
            <li>
              Email us directly at <a href='support@herbalteatherapy.com' className='hover:underline text-blue-600'>support@herbalteatherapy.com</a> with the subject line “Unsubscribe”.

            </li>
          </ul>
        </DataWrapper>
        {/* 10 */}
        <DataWrapper heading="CURRENCY CONVERTING">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            By using our website, you (the visitor) agree to allow third parties to process your IP address to determine your location for currency conversion purposes. You also agree to have that currency stored in a session cookie in your browser (a temporary cookie that gets automatically removed when you close your browser). We do this so that the selected currency remains consistent when browsing our website, allowing prices to convert to your local currency.
          </p>
        </DataWrapper>
        {/* 11 */}
        <DataWrapper heading="THIRD-PARTY PIXELS AND COOKIES">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Notwithstanding anything else in this policy, we and/or our partners may use pixels, pixel tags, and place, read, or use cookies that collect information from your device and/or internet browser. These cookies do not contain personally identifiable information, but our third-party business partners may combine it with other information to identify your email address or other personal information.
          </p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            By using our Service, you agree that we and our third-party partners may store, sell, combine with other data, monetize, utilize, and otherwise use:
          </p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px] list-disc ml-8">
            <li>
              The personally identifiable information about you that we share with them.
            </li>
            <li>
              The personally identifiable information they discover and/or identify as described above.
            </li>
          </ul>

          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Opting Out of Personalized Advertising:
          </p>
          <ul className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px] list-disc ml-8">
            <li>
              Visitors can express their choices for display advertising through:
            </li>
            <li>
              Digital Advertising Alliance opt-out platform
            </li>
            <li>
              Network Advertising Initiative opt-out platform
            </li>
          </ul>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            We and/or our partners may also use cookies for delivering personalized advertising emails based on your browsing experience.
          </p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            Respoclear.net uses cookies to track items in your shopping cart, including when you have abandoned your cart. This information is used to determine when to send cart reminder messages via SMS.

          </p>
        </DataWrapper>
        {/* 12 */}
        <DataWrapper heading="THIRD-PARTY PIXELS AND COOKIES">
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-normal  mb-[15px]">
            When you visit our website, log in, register, or open an email, cookies, ad beacons, and similar technologies may be used by our online data partners or vendors to associate these activities with information they or others have about you, including your email address. We (or service providers on our behalf) may then send communications and marketing to these email addresses.
          </p>
          <p className="text-[#181818] font-['Myriad_Pro'] text-lg font-bold  mb-[15px]">
            Opting Out:<br />
            <span className='font-normal'>
              You may opt out of receiving this advertising by visiting:
            </span>
            <br />
            <a href='https://app.retention.com/optout' className='hover:underline text-blue-600'>

              https://app.retention.com/optout
            </a>



          </p>

        </DataWrapper>
        <div className='flex items-center justify-center w-full'>
          <Copywrite />
        </div>
      </div>
    </div>
  )
}
export default Privacy